// import React, { useState } from 'react';
// import {
//   Dialog,
//   DialogContent,
//   DialogHeader,
//   DialogTitle,
// } from './ui/dialog';
// import { Button } from './ui/button';
// import { Input } from './ui/input';
// import { Checkbox } from './ui/checkbox';
// import { Mail, Phone, Clock, ArrowRight, CheckCircle2 } from 'lucide-react';

// export default function ContactModal({ isOpen, onClose, defaultDemo = false }) {
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     phone: '',
//     subject: '',
//     message: '',
//     wantDemo: defaultDemo,
//   });
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [isSubmitted, setIsSubmitted] = useState(false);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!formData.name || !formData.email) return;
    
//     setIsSubmitting(true);
//     // Simulate API call
//     await new Promise((r) => setTimeout(r, 1500));
//     setIsSubmitting(false);
//     setIsSubmitted(true);
//   };

//   const handleClose = () => {
//     onClose();
//     // Reset form after modal closes
//     setTimeout(() => {
//       setFormData({
//         name: '',
//         email: '',
//         phone: '',
//         subject: '',
//         message: '',
//         wantDemo: defaultDemo,
//       });
//       setIsSubmitted(false);
//     }, 200);
//   };

//   return (
//     <Dialog open={isOpen} onOpenChange={handleClose}>
//       <DialogContent className="sm:max-w-2xl max-h-[90vh] overflow-y-auto p-0">
//         {!isSubmitted ? (
//           <div className="flex flex-col">
//             {/* Header */}
//             <DialogHeader className="px-8 pt-8 pb-4">
//               <DialogTitle className="text-3xl font-light tracking-tight text-gray-900">
//                 Contact us
//               </DialogTitle>
//               <p className="text-base text-gray-500 font-light mt-2">
//                 We are here to help you.
//               </p>
//             </DialogHeader>

//             {/* Contact Info Row */}
//             <div className="px-8 py-4 grid grid-cols-1 sm:grid-cols-3 gap-4 border-b border-gray-100">
//               <div className="flex items-center gap-3">
//                 <div className="w-10 h-10 rounded-full bg-gray-900 flex items-center justify-center flex-shrink-0">
//                   <Mail className="w-4 h-4 text-white" />
//                 </div>
//                 <div>
//                   <p className="text-xs text-gray-400 uppercase tracking-wide">Email</p>
//                   <p className="text-sm text-gray-900">info@longfloat.com</p>
//                 </div>
//               </div>
//               <div className="flex items-center gap-3">
//                 <div className="w-10 h-10 rounded-full bg-gray-900 flex items-center justify-center flex-shrink-0">
//                   <Phone className="w-4 h-4 text-white" />
//                 </div>
//                 <div>
//                   <p className="text-xs text-gray-400 uppercase tracking-wide">Phone</p>
//                   <p className="text-sm text-gray-900">+91 7702727788</p>
//                 </div>
//               </div>
//               <div className="flex items-center gap-3">
//                 <div className="w-10 h-10 rounded-full bg-gray-900 flex items-center justify-center flex-shrink-0">
//                   <Clock className="w-4 h-4 text-white" />
//                 </div>
//                 <div>
//                   <p className="text-xs text-gray-400 uppercase tracking-wide">Hours</p>
//                   <p className="text-sm text-gray-900">Mon - Sat 9:00 - 18:00</p>
//                 </div>
//               </div>
//             </div>

//             {/* Form */}
//             <form onSubmit={handleSubmit} className="px-8 py-6 space-y-5">
//               {/* Name & Email Row */}
//               <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//                 <div>
//                   <label className="block text-sm text-gray-600 mb-1.5">
//                     Your Name <span className="text-red-500">*</span>
//                   </label>
//                   <Input
//                     name="name"
//                     value={formData.name}
//                     onChange={handleChange}
//                     placeholder="John Doe"
//                     required
//                     className="w-full"
//                   />
//                 </div>
//                 <div>
//                   <label className="block text-sm text-gray-600 mb-1.5">
//                     Email <span className="text-red-500">*</span>
//                   </label>
//                   <Input
//                     name="email"
//                     type="email"
//                     value={formData.email}
//                     onChange={handleChange}
//                     placeholder="you@example.com"
//                     required
//                     className="w-full"
//                   />
//                 </div>
//               </div>

//               {/* Phone & Subject Row */}
//               <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//                 <div>
//                   <label className="block text-sm text-gray-600 mb-1.5">
//                     Phone Number
//                   </label>
//                   <Input
//                     name="phone"
//                     type="tel"
//                     value={formData.phone}
//                     onChange={handleChange}
//                     placeholder="+1 234 567 8900"
//                     className="w-full"
//                   />
//                 </div>
//                 <div>
//                   <label className="block text-sm text-gray-600 mb-1.5">
//                     Subject
//                   </label>
//                   <Input
//                     name="subject"
//                     value={formData.subject}
//                     onChange={handleChange}
//                     placeholder="How can we help?"
//                     className="w-full"
//                   />
//                 </div>
//               </div>

//               {/* Message */}
//               <div>
//                 <label className="block text-sm text-gray-600 mb-1.5">
//                   Message (Optional)
//                 </label>
//                 <textarea
//                   name="message"
//                   value={formData.message}
//                   onChange={handleChange}
//                   placeholder="Tell us more about your needs..."
//                   rows={4}
//                   className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-gray-900 focus:border-transparent resize-none"
//                 />
//               </div>

//               {/* Demo Checkbox & Submit */}
//               <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 pt-2">
//                 <div className="flex items-center gap-2">
//                   <Checkbox
//                     id="wantDemo"
//                     checked={formData.wantDemo}
//                     onCheckedChange={(checked) =>
//                       setFormData((prev) => ({ ...prev, wantDemo: checked }))
//                     }
//                   />
//                   <label
//                     htmlFor="wantDemo"
//                     className="text-sm text-gray-600 cursor-pointer"
//                   >
//                     Want to Book a Free Demo
//                   </label>
//                 </div>
//                 <Button
//                   type="submit"
//                   disabled={isSubmitting || !formData.name || !formData.email}
//                   className="bg-gray-900 hover:bg-gray-800 text-white px-8 py-5 text-sm font-normal rounded-lg transition-all duration-300 group"
//                 >
//                   {isSubmitting ? 'Submitting...' : 'Submit'}
//                   {!isSubmitting && (
//                     <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
//                   )}
//                 </Button>
//               </div>
//             </form>
//           </div>
//         ) : (
//           /* Success State */
//           <div className="px-8 py-16 text-center">
//             <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gray-100 text-gray-900 mb-6">
//               <CheckCircle2 className="w-8 h-8" strokeWidth={1.5} />
//             </div>
//             <h3 className="text-2xl font-light tracking-tight text-gray-900 mb-3">
//               Thank you for reaching out!
//             </h3>
//             <p className="text-base text-gray-600 font-light mb-2">
//               We've received your message and will get back to you shortly.
//             </p>
//             {formData.wantDemo && (
//               <p className="text-sm text-gray-500 mb-6">
//                 Our team will contact you to schedule your demo.
//               </p>
//             )}
//             <Button
//               onClick={handleClose}
//               variant="outline"
//               className="border-gray-300 hover:border-gray-900 hover:bg-gray-900 hover:text-white transition-all duration-300"
//             >
//               Close
//             </Button>
//           </div>
//         )}
//       </DialogContent>
//     </Dialog>
//   );
// }




import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Checkbox } from "./ui/checkbox";
import { Mail, Phone, Clock, ArrowRight, CheckCircle2 } from "lucide-react";

import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";

export default function ContactModal({ isOpen, onClose, defaultDemo = false }) {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
    wantDemo: defaultDemo,
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name || !formData.email) return;

    setIsSubmitting(true);

    try {
      await addDoc(collection(db, "contact_requests"), {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        subject: formData.subject,
        message: formData.message,
        bookDemo: formData.wantDemo,
        createdAt: serverTimestamp(),
      });

      setIsSubmitted(true);
    } catch (error) {
      console.error("Error saving contact request:", error);
      alert("Something went wrong. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    onClose();
    setTimeout(() => {
      setFormData({
        name: "",
        email: "",
        phone: "",
        subject: "",
        message: "",
        wantDemo: defaultDemo,
      });
      setIsSubmitted(false);
    }, 200);
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleClose}>
      <DialogContent className="w-[96vw] max-w-none sm:max-w-2xl max-h-[92dvh] overflow-y-auto p-0 rounded-xl sm:rounded-2xl">
        {!isSubmitted ? (
          <div className="flex flex-col">
            <DialogHeader className="px-5 sm:px-8 pt-6 sm:pt-8 pb-4">
              <DialogTitle className="text-2xl sm:text-3xl font-light tracking-tight text-gray-900">
                Contact us
              </DialogTitle>
              <p className="text-sm sm:text-base text-gray-500 font-light mt-2">
                We are here to help you.
              </p>
            </DialogHeader>

            <div className="px-5 sm:px-8 py-4 grid grid-cols-1 sm:grid-cols-3 gap-4 border-b border-gray-100">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-gray-900 flex items-center justify-center">
                  <Mail className="w-4 h-4 text-white" />
                </div>
                <div>
                  <p className="text-xs text-gray-400 uppercase">Email</p>
                  <p className="text-sm text-gray-900">info@longfloat.com</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-gray-900 flex items-center justify-center">
                  <Phone className="w-4 h-4 text-white" />
                </div>
                <div>
                  <p className="text-xs text-gray-400 uppercase">Phone</p>
                  <p className="text-sm text-gray-900">+91 7702727788</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-gray-900 flex items-center justify-center">
                  <Clock className="w-4 h-4 text-white" />
                </div>
                <div>
                  <p className="text-xs text-gray-400 uppercase">Hours</p>
                  <p className="text-sm text-gray-900">Mon - Sat 9:00 - 18:00</p>
                </div>
              </div>
            </div>

            <form onSubmit={handleSubmit} className="px-5 sm:px-8 py-5 sm:py-6 space-y-4 sm:space-y-5">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <Input name="name" value={formData.name} onChange={handleChange} placeholder="John Doe" required />
                <Input name="email" type="email" value={formData.email} onChange={handleChange} placeholder="you@example.com" required />
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <Input name="phone" value={formData.phone} onChange={handleChange} placeholder="+1 234 567 8900" />
                <Input name="subject" value={formData.subject} onChange={handleChange} placeholder="How can we help?" />
              </div>

              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Tell us more about your needs..."
                rows={4}
                className="w-full px-3 py-2 border rounded-lg resize-none"
              />

              <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                <div className="flex items-center gap-2">
                  <Checkbox
                    checked={formData.wantDemo}
                    onCheckedChange={(checked) =>
                      setFormData((p) => ({ ...p, wantDemo: checked }))
                    }
                  />
                  <span className="text-sm">Want to Book a Free Demo</span>
                </div>

                <Button type="submit" disabled={isSubmitting} className="w-full sm:w-auto">
                  {isSubmitting ? "Submitting..." : "Submit"}
                  <ArrowRight className="ml-2 w-4 h-4" />
                </Button>
              </div>
            </form>
          </div>
        ) : (
          <div className="px-5 sm:px-8 py-12 sm:py-16 text-center">
            <CheckCircle2 className="mx-auto mb-4 w-8 h-8" />
            <h3 className="text-xl mb-2">Thank you for reaching out!</h3>
            <Button onClick={handleClose} className="w-full sm:w-auto">Close</Button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
